let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bU8uA")).then(() => parcelRequire('i3h4u'));